'use client';

import { useEffect } from 'react';

export function SubVideo() {
  useEffect(() => {
    window?.SUBVID?.run();
    return () => {
      window?.SUBVID?.destroyPlayers();
    };
  }, []);
  return (
    <>
      <script async src="https://player.subvid.ai/js/vq_starter.js" />
      <div
        style={{ width: '100%', height: '0' }}
        data-playerId="397"
        data-profileId="359"
        className="subvid-article-widget"
      />
    </>
  );
}
